"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.actionCreator = actionCreator;
exports.buildSourcePayload = buildSourcePayload;
exports.handleMultipartUpload = handleMultipartUpload;
exports.isSameAttendee = isSameAttendee;
exports.recursiveFunction = recursiveFunction;
exports.toggleLocalUserAudioTrack = toggleLocalUserAudioTrack;
exports.toggleLocalUserVideoTrack = toggleLocalUserVideoTrack;
exports.toggleOverlayStatus = toggleOverlayStatus;
exports.uploadToPreSignedURL = uploadToPreSignedURL;
exports.withTimeout = withTimeout;
var _axios = _interopRequireDefault(require("axios"));
var _retryUtil = require("./retryUtil");
var _md = _interopRequireDefault(require("md5"));
var _commonWebAnalytics = require("@studio/metrics/client/web/commonWebAnalytics");
var _videoHelpers = require("@cvent/studio-agora/video/videoHelpers");
var _audioHelper = require("@cvent/studio-agora/audio/audioHelper");
var _addToAttendeeTiles = _interopRequireDefault(require("../actions/meeting/addToAttendeeTiles"));
var _setVideoInputDevice = _interopRequireDefault(require("../actions/meeting/setVideoInputDevice"));
var _showNotification = _interopRequireDefault(require("../actions/notification/showNotification"));
var _setGenericAudioInputDevice = _interopRequireDefault(require("../actions/meeting/setGenericAudioInputDevice"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
/**
 * Checks if meeting attendee response attendeeId is same as the attendeeId
 * parameter passed in.
 *
 * @param {String} attendeeId
 * @param {Object} state
 *
 * @return {Boolean} returns true of its meting attendee is same
 */
function isSameAttendee(attendeeId, state) {
  var _state$meeting;
  var localAttendeeId = state === null || state === void 0 || (_state$meeting = state.meeting) === null || _state$meeting === void 0 ? void 0 : _state$meeting.attendeeId;
  return attendeeId === localAttendeeId;
}

/**
 *
 * @param {*} onSuccess
 * @param {*} onTimeout
 * @param {*} timeout
 */
function withTimeout(onSuccess, onTimeout, timeout) {
  var _this = this;
  var called = false;
  var timer = setTimeout(function () {
    if (called) return;
    called = true;
    onTimeout();
  }, timeout);
  return function () {
    if (called) return;
    called = true;
    clearTimeout(timer);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    onSuccess.apply(_this, args);
  };
}

/**
 *
 * @param {*} func
 * @param {*} retries
 */
function recursiveFunction(_x, _x2) {
  return _recursiveFunction.apply(this, arguments);
}
/**
 * Basic action creator. Usage:
 *
 * import { SOME_TYPE } from './types';
 import actionCreator from 'creator';
 export default (delta) => actionCreator(SOME_TYPE, {some: 'payload'});;
 *
 * @param {*} type
 * @param {*} payload
 * @param {*?} additionalActions - arrays of additional actions to be dispatched. e.g, [() => togleNotificationList(true)]
 * @returns
 */
function _recursiveFunction() {
  _recursiveFunction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(func, retries) {
    var resp, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          _context.p = 0;
          _context.n = 1;
          return func();
        case 1:
          resp = _context.v;
          return _context.a(2, resp);
        case 2:
          _context.p = 2;
          _t = _context.v;
          --retries;
          if (!(retries > 0)) {
            _context.n = 3;
            break;
          }
          return _context.a(2, recursiveFunction(func, retries));
        case 3:
          throw _t;
        case 4:
          return _context.a(2);
      }
    }, _callee, null, [[0, 2]]);
  }));
  return _recursiveFunction.apply(this, arguments);
}
function actionCreator(type, payload, additionalActions) {
  return function (dispatch) {
    var action = {
      type: type,
      payload: payload
    };
    dispatch(action);
    additionalActions === null || additionalActions === void 0 || additionalActions.map(function (additionalAction) {
      dispatch(additionalAction());
    });
  };
}

/**
 * Util for toggling the hidden status of an overlays
 * with the following structure [{ _id, layer: {}, source: {}}]
 * We can have multiple overlays un-hidden
 * @param {*} overlayId
 * @param {*} overlays
 * @returns
 */

function toggleOverlayStatus(overlayId, overlays) {
  return overlays.map(function (overlay) {
    var source = overlay.source,
      _id = overlay._id;
    return _id === overlayId ? _objectSpread(_objectSpread({}, overlay), {}, {
      source: _objectSpread(_objectSpread({}, source), {}, {
        hidden: !source.hidden
      })
    }) : overlay;
  });
}

/**
 * Upload the binary data content to the pre-signed URL
 * @param {*} preSignedUploadUrl S3 Pre-signed URL where the content should be uploaded
 * @param {*} binaryData         Binary Data
 * @param {*} contentType        Content Type header
 * @param {*} headers            Additional headers
 */
function uploadToPreSignedURL(_x3, _x4, _x5, _x6) {
  return _uploadToPreSignedURL.apply(this, arguments);
}
/**
 * Convert part blob to the binary content
 * @param {*} blobChunk - Blob chunk
 * @returns  {Uint8Array} - Binary content
 */
function _uploadToPreSignedURL() {
  _uploadToPreSignedURL = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(preSignedUploadUrl, binaryData, contentType, headers) {
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          _context3.n = 1;
          return (0, _retryUtil.retryWithDefaults)(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
            return _regenerator().w(function (_context2) {
              while (1) switch (_context2.n) {
                case 0:
                  _context2.n = 1;
                  return _axios["default"].put(preSignedUploadUrl, binaryData, {
                    headers: _objectSpread({
                      'Content-Type': contentType
                    }, headers && {
                      'x-amz-tagging': headers
                    })
                  });
                case 1:
                  return _context2.a(2, _context2.v);
              }
            }, _callee2);
          })))["catch"](function (error) {
            throw error;
          });
        case 1:
          return _context3.a(2, _context3.v);
      }
    }, _callee3);
  }));
  return _uploadToPreSignedURL.apply(this, arguments);
}
function blobToBinary(_x7) {
  return _blobToBinary.apply(this, arguments);
}
/**
 * Upload the part to the part S3 Pre-signed URL
 * @param {*} partUploadURL  - S3 Pre-signed URL where the content should be uploaded
 * @param {*} part           - Binary Data to be uploaded
 * @param {*} headers         - Additional headers
 * @returns                   - Promise
 */
function _blobToBinary() {
  _blobToBinary = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(blobChunk) {
    var buffer;
    return _regenerator().w(function (_context4) {
      while (1) switch (_context4.n) {
        case 0:
          _context4.n = 1;
          return blobChunk.arrayBuffer();
        case 1:
          buffer = _context4.v;
          return _context4.a(2, new Uint8Array(buffer));
      }
    }, _callee4);
  }));
  return _blobToBinary.apply(this, arguments);
}
function uploadPart(_x8, _x9, _x0) {
  return _uploadPart.apply(this, arguments);
}
/**
 *  Upload the file using the multi-part upload workflow
 * @param {*} apiClient                     - API client instance
 * @param {*} teamId                        - Team ID
 * @param {*} eventId                       - Event ID
 * @param {*} docPayload                    - Event Doc payload
 * @param {*} file                          - File to be uploaded
 * @param {*} startFileUploadActionCallback - Callback to start file upload action
 */
function _uploadPart() {
  _uploadPart = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(partUploadURL, part, headers) {
    return _regenerator().w(function (_context6) {
      while (1) switch (_context6.n) {
        case 0:
          _context6.n = 1;
          return (0, _retryUtil.retryWithDefaults)(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
            return _regenerator().w(function (_context5) {
              while (1) switch (_context5.n) {
                case 0:
                  _context5.n = 1;
                  return _axios["default"].put(partUploadURL, part, {
                    headers: headers
                  });
                case 1:
                  return _context5.a(2, _context5.v);
              }
            }, _callee5);
          })))["catch"](function (error) {
            throw error;
          });
        case 1:
          return _context6.a(2, _context6.v);
      }
    }, _callee6);
  }));
  return _uploadPart.apply(this, arguments);
}
function handleMultipartUpload(_x1, _x10, _x11, _x12, _x13, _x14) {
  return _handleMultipartUpload.apply(this, arguments);
}
/**
 * Toggles the local user's video track on or off.
 *
 * @param {Object} params - The parameters object
 * @param {Object|null} params.currentVideoTrack - The current video track object, or null if no track exists
 * @param {boolean} params.isCameraOn - Current camera state (true if on, false if off)
 * @param {Object} params.client - The Agora client instance
 * @param {Function} params.dispatch - Redux dispatch function
 * @param {string} params.attendeeId - The ID of the attendee toggling their video
 * @param {boolean} [params.isRemoteToggle=false] - Whether this is a remote toggle action
 * @returns {Promise<Object|null>} Returns the new video track object, or null if video is turned off
 */
function _handleMultipartUpload() {
  _handleMultipartUpload = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(apiClient, teamId, eventId, docPayload, file, startFileUploadActionCallback) {
    var CHUNK_SIZE, UPLOAD_BATCH_SIZE, createDocumentResponse, eventDocId, uploadId, externalVideoId, fileSize, totalChunks, data, partUploadPromises, index, blob, start, end, binary, md5Hash, blobHash, payload, generatePartUploadURLResponse, location, headers, partEtags, completeUploadPayload, _t2, _t3, _t4, _t5, _t6, _t7;
    return _regenerator().w(function (_context7) {
      while (1) switch (_context7.n) {
        case 0:
          CHUNK_SIZE = 1024 * 1024 * 30; // 30MB chunks
          UPLOAD_BATCH_SIZE = 4;
          _context7.n = 1;
          return apiClient.eventDoc.createDocument(teamId, eventId, docPayload);
        case 1:
          createDocumentResponse = _context7.v;
          eventDocId = createDocumentResponse._id, uploadId = createDocumentResponse.uploadId, externalVideoId = createDocumentResponse.externalVideoId; // Start file upload action tracker
          startFileUploadActionCallback === null || startFileUploadActionCallback === void 0 || startFileUploadActionCallback({
            externalVideoId: externalVideoId
          });
          fileSize = file.size;
          totalChunks = Math.ceil(fileSize / CHUNK_SIZE);
          data = [];
          partUploadPromises = [];
          index = 0;
        case 2:
          if (!(index < totalChunks)) {
            _context7.n = 7;
            break;
          }
          blob = void 0;
          start = index * CHUNK_SIZE;
          end = (index + 1) * CHUNK_SIZE;
          if (end > file.size) {
            blob = file.slice(start, file.size);
          } else {
            blob = file.slice(start, end);
          }

          // calculate md5 hash for the part
          _context7.n = 3;
          return blobToBinary(blob);
        case 3:
          binary = _context7.v;
          md5Hash = (0, _md["default"])(binary);
          blobHash = btoa((md5Hash.match(/\w{2}/g) || []).map(function (a) {
            return String.fromCharCode(parseInt(a, 16));
          }).join(''));
          payload = {
            name: file.name,
            uploadId: uploadId,
            part: {
              md5CheckSum: blobHash,
              partNumber: index + 1,
              contentLength: blob.size
            }
          };
          _context7.n = 4;
          return apiClient.eventDoc.generatePartUploadURL(teamId, eventId, eventDocId, payload);
        case 4:
          generatePartUploadURLResponse = _context7.v;
          location = generatePartUploadURLResponse.location;
          headers = {
            'Content-MD5': blobHash,
            'Content-Type': 'application/octet-stream'
          };
          partUploadPromises.push(uploadPart(location, blob, headers));
          if (!(partUploadPromises.length === UPLOAD_BATCH_SIZE)) {
            _context7.n = 6;
            break;
          }
          _t2 = [];
          _t3 = _toConsumableArray(data);
          _t4 = _toConsumableArray;
          _context7.n = 5;
          return Promise.all(partUploadPromises);
        case 5:
          data = _t2.concat.call(_t2, _t3, _t4(_context7.v));
          partUploadPromises = [];
        case 6:
          index++;
          _context7.n = 2;
          break;
        case 7:
          if (!(partUploadPromises.length > 0)) {
            _context7.n = 9;
            break;
          }
          _t5 = [];
          _t6 = _toConsumableArray(data);
          _t7 = _toConsumableArray;
          _context7.n = 8;
          return Promise.all(partUploadPromises);
        case 8:
          data = _t5.concat.call(_t5, _t6, _t7(_context7.v));
        case 9:
          partEtags = [];
          data.forEach(function (resolvedPromise, index) {
            var _resolvedPromise$head;
            partEtags.push({
              eTag: resolvedPromise === null || resolvedPromise === void 0 || (_resolvedPromise$head = resolvedPromise.headers) === null || _resolvedPromise$head === void 0 || (_resolvedPromise$head = _resolvedPromise$head.etag) === null || _resolvedPromise$head === void 0 ? void 0 : _resolvedPromise$head.replace(/"/g, ''),
              partNumber: index + 1
            });
          });
          completeUploadPayload = {
            uploadId: uploadId,
            partEtags: partEtags
          };
          _context7.n = 10;
          return apiClient.eventDoc.completeMultiPartUpload(teamId, eventId, eventDocId, completeUploadPayload);
        case 10:
          return _context7.a(2, {
            eventDocId: eventDocId,
            externalVideoId: externalVideoId
          });
      }
    }, _callee7);
  }));
  return _handleMultipartUpload.apply(this, arguments);
}
function toggleLocalUserVideoTrack(_x15) {
  return _toggleLocalUserVideoTrack.apply(this, arguments);
}
/**
 *
 * @param {Object} params                         - The parameters object
 * @param {Object} params.currentAudioTrack       - The current local audio track
 * @param {boolean} params.isMuted                - The desired mute status
 * @param {Object} params.client                  - The Agora client instance
 * @param {Function} params.dispatch              - The Redux dispatch function
 * @param {boolean} [params.isRemoteToggle=false] - Indicates if the toggle is triggered remotely (defaults to false)
 *
 * @returns {Promise<void>} - Returns a promise that resolves when the audio track has been toggled

 */
function _toggleLocalUserVideoTrack() {
  _toggleLocalUserVideoTrack = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(_ref) {
    var currentVideoTrack, isCameraOn, client, dispatch, attendeeId, _ref$isRemoteToggle, isRemoteToggle, deviceActions, sliPayload, newTrack, _t8;
    return _regenerator().w(function (_context8) {
      while (1) switch (_context8.p = _context8.n) {
        case 0:
          currentVideoTrack = _ref.currentVideoTrack, isCameraOn = _ref.isCameraOn, client = _ref.client, dispatch = _ref.dispatch, attendeeId = _ref.attendeeId, _ref$isRemoteToggle = _ref.isRemoteToggle, isRemoteToggle = _ref$isRemoteToggle === void 0 ? false : _ref$isRemoteToggle;
          deviceActions = {
            addToAttendeeTiles: _addToAttendeeTiles["default"],
            handleVideoInputChanged: _setVideoInputDevice["default"],
            handleAudioInputChanged: _setGenericAudioInputDevice["default"],
            showNotification: _showNotification["default"]
          };
          sliPayload = {
            cameraState: isCameraOn ? 'ON' : 'OFF',
            isRemoteToggle: isRemoteToggle
          };
          _context8.p = 1;
          _commonWebAnalytics.commonWebAnalytics.startStudioCameraToggled(sliPayload);
          _context8.n = 2;
          return (0, _videoHelpers.toggleAgoraVideo)(currentVideoTrack, isCameraOn, client, dispatch, deviceActions, attendeeId);
        case 2:
          newTrack = _context8.v;
          if (!currentVideoTrack && newTrack) {
            dispatch((0, _addToAttendeeTiles["default"])(attendeeId, newTrack));
          }
          _commonWebAnalytics.commonWebAnalytics.endStudioCameraToggled(sliPayload);
          return _context8.a(2, newTrack);
        case 3:
          _context8.p = 3;
          _t8 = _context8.v;
          _commonWebAnalytics.commonWebAnalytics.endStudioCameraToggled(_objectSpread(_objectSpread({}, sliPayload), {}, {
            error: _t8 === null || _t8 === void 0 ? void 0 : _t8.message
          }));
          throw _t8;
        case 4:
          return _context8.a(2);
      }
    }, _callee8, null, [[1, 3]]);
  }));
  return _toggleLocalUserVideoTrack.apply(this, arguments);
}
function toggleLocalUserAudioTrack(_x16) {
  return _toggleLocalUserAudioTrack.apply(this, arguments);
}
/**
 * Builds the payload object for a broadcast source.
 *
 * @param {Object} payload - The raw source payload
 * @param {boolean} payload.cameraUnavailable - Whether the camera is unavailable
 * @param {string} payload.description - The description of the source
 * @param {number} payload.order - The order of the source
 * @param {string} payload.role - The role of the source
 * @param {string} payload.title - The title of the source
 * @param {string} payload.type - The type of the source
 * @param {string} payload.value - The value of the source
 * @param {string} payload.userId - The userId for the source
 * @returns {Object} The broadcast source payload
 */
function _toggleLocalUserAudioTrack() {
  _toggleLocalUserAudioTrack = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(_ref2) {
    var currentAudioTrack, isMuted, client, dispatch, _ref2$isRemoteToggle, isRemoteToggle, deviceActions, sliPayload, _t9;
    return _regenerator().w(function (_context9) {
      while (1) switch (_context9.p = _context9.n) {
        case 0:
          currentAudioTrack = _ref2.currentAudioTrack, isMuted = _ref2.isMuted, client = _ref2.client, dispatch = _ref2.dispatch, _ref2$isRemoteToggle = _ref2.isRemoteToggle, isRemoteToggle = _ref2$isRemoteToggle === void 0 ? false : _ref2$isRemoteToggle;
          deviceActions = {
            handleAudioInputChanged: _setGenericAudioInputDevice["default"],
            showNotification: _showNotification["default"]
          };
          sliPayload = {
            microphoneState: isMuted ? 'OFF' : 'ON',
            isRemoteToggle: isRemoteToggle
          };
          _context9.p = 1;
          _commonWebAnalytics.commonWebAnalytics.startStudioMicrophoneToggled(sliPayload);
          _context9.n = 2;
          return (0, _audioHelper.muteLocalAudioStream)(currentAudioTrack, isMuted, client, dispatch, deviceActions);
        case 2:
          _commonWebAnalytics.commonWebAnalytics.endStudioMicrophoneToggled(sliPayload);
          _context9.n = 4;
          break;
        case 3:
          _context9.p = 3;
          _t9 = _context9.v;
          _commonWebAnalytics.commonWebAnalytics.endStudioMicrophoneToggled(_objectSpread(_objectSpread({}, sliPayload), {}, {
            error: _t9 === null || _t9 === void 0 ? void 0 : _t9.message
          }));
          throw _t9;
        case 4:
          return _context9.a(2);
      }
    }, _callee9, null, [[1, 3]]);
  }));
  return _toggleLocalUserAudioTrack.apply(this, arguments);
}
function buildSourcePayload(payload) {
  var order = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  if (order !== undefined) {
    return {
      cameraUnavailable: payload.cameraUnavailable,
      description: payload.description,
      order: order,
      role: payload.role,
      title: payload.title,
      type: payload.type,
      value: payload.value,
      userId: payload.userId
    };
  } else {
    return {
      cameraUnavailable: payload.cameraUnavailable,
      description: payload.description,
      role: payload.role,
      title: payload.title,
      type: payload.type,
      value: payload.value,
      userId: payload.userId
    };
  }
}